import { cn } from "@utils/utils"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"

import Button from "@components/Button/Button"

const texts = {
  fr: {
    title: "Contactez-nous !",
    description:
      "Une question sur nos produits ? Vous voulez contacter notre bureau d'études pour étudier votre projet ? N'hésitez pas, nous sommes disponibles via chat, téléphone ou email",
    buttonString: "Nous contacter",
    buttonURL: "/contact/",
  },
  de: {
    title: "Haben Sie eine Frage? ",
    description:
      "Möchten Sie unser Planungsbüro kontaktieren, um Ihr Projekt zu studieren? Wir sind per Chat, Telefon oder E-Mail erreichbar.",
    buttonString: "Kontaktiere uns",
    buttonURL: "/de/kontakt/",
  },
  en: {
    title: "Contact us!",
    description:
      "A question about our products ? Do you want to contact our design office to study your project? Do not hesitate, we are available via chat, phone or email",
    buttonString: "Contact",
    buttonURL: "/en/contact/",
  },
}

const ContactUs = ({ lang, className = null, id = null }) => {
  const data = useStaticQuery(graphql`
    {
      file(
        name: { eq: "contact_page_hotline" }
        sourceInstanceName: { eq: "images" }
      ) {
        id
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED)
        }
        name
      }
    }
  `)
  return (
    <div className={cn("overflow-hidden bg-white pt-16 sm:pt-20", className)}>
      <div className="mx-auto">
        <div className="mx-auto grid max-w-2xl grid-cols-1 lg:mx-0 lg:max-w-none lg:grid-cols-2">
          <div className="flex items-center justify-center bg-fehr-500 lg:pl-4 lg:pt-4">
            <div className="flex flex-col gap-y-2 p-6 lg:max-w-lg lg:p-0">
              <h2
                {...(id ? { id } : {})}
                className="m-0 text-3xl font-bold tracking-tight text-gray-50 sm:text-4xl"
              >
                {texts[lang].title}
              </h2>
              <p className="text-base leading-6 text-gray-100">
                {texts[lang].description}
              </p>
              <Button
                buttonString={texts[lang].buttonString}
                buttonURL={texts[lang].buttonURL}
                contactfrom={true}
              />
            </div>
          </div>
          <div className="flex items-start justify-end lg:order-first">
            <GatsbyImage
              image={getImage(data.file)!}
              alt={data.file.name || ""}
              className="h-full max-w-none"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactUs
